var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5047 5.59437V4H15.9103V5.59437H9.49531V4H7.90094V5.59437H7.09437C6.6567 5.59437 6.28156 5.75068 5.96893 6.06331C5.65631 6.37593 5.5 6.75732 5.5 7.2075V18.4056C5.5 18.8433 5.65631 19.2184 5.96893 19.5311C6.28156 19.8437 6.6567 20 7.09437 20H18.3113C18.7489 20 19.1241 19.8437 19.4367 19.5311C19.7493 19.2184 19.9056 18.8433 19.9056 18.4056V7.2075C19.9056 6.75732 19.7493 6.37593 19.4367 6.06331C19.1241 5.75068 18.7489 5.59437 18.3113 5.59437H17.5047ZM18.3113 18.4056H7.09437V9.60844H18.3113V18.4056ZM8.7075 15.1981H12.7028V11.2028H8.7075V15.1981Z",
    fill: "#E00D7B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.f3858443.svg";
export { ForwardRef as ReactComponent };